// @ts-nocheck
import AppConfigs from "configs/env";
import { END_POINTS } from "constants/apiUrl";
import { APIUtils } from "utils";

export const getProvincesApi = (payload) => {
    return APIUtils.get(END_POINTS.GET_PROVINCES_URL, {
        params: payload,
    });
};

export const getDistrictsApi = (payload) => {
    return APIUtils.get(`${END_POINTS.GET_DISTRICTS_URL}${payload?.provinceId}/Districts`);
};

export const getCommunesApi = (payload) => {
    return APIUtils.get(`${END_POINTS.GET_COMMUNES_URL}${payload?.districtId}/Commune`);
};

export const deliveryInfoApi = (payload) => {
    return APIUtils.post(END_POINTS.DELIVERYINFO_URL, {
        body: payload,
    });
};
